import {Feature} from 'acng/core/model/feature.js';

const name = 'picturePool';
export default name;
export const picturePoolFeature = new Feature(name);
